import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import OEIcon from '../../../elements/oe-icon';
import {OEIconButton} from '../../../elements/controls/oe-button';
import {OENumberPickerButton} from '../../../elements/oe-number-picker';
import OEColor from '../../../color-picker/oe-color';
import {OEColorPickerNumericInputType, OEColorPickerButton} from '../../../color-picker/oe-color-picker';
import {OEPopoverMenu} from '../../../views/oe-popover-menu';
import {OENumberPickerPopover} from '../../../elements/oe-number-picker';
import {OEPresetType} from '../../preset/oe-preset-model';
import {OEPresetPopoverController} from '../../preset/oe-preset-controller';
import {OENoteAddStatePopoverController} from '../oe-note-add-state-controller';
import {OENoteAttributePopoverController} from '../oe-note-attribute-controller';
import {OENoteFunctionPopoverController} from '../oe-note-function-controller';
import {OENoteExtPopoverController} from '../oe-note-ext-controller';
import {OENotePropertyTransferPopoverController} from '../oe-note-property-transfer-controller';
import OENoteStateProvider from './oe-note-state-provider';
import {OENoteToolbarViewTypes} from '../oe-note-model';

export default class OENoteToolbar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.id = typeof(this.props.id) === 'number' ? this.props.id : null;

        this.state = {
            id:                             this.id,
            noteState:                      OENoteStateProvider.defaultNoteState(),
            isFontSizePopoverOpen:          false,
            isHAlignmentMenuOpen:           false,
            isVAlignmentMenuOpen:           false,
            isPresetPopoverOpen:            false,
            openViews:                      [],
        };

        this.onNoteStateChanged = this.onNoteStateChanged.bind(this);

        this.onFontSizePopoverRef = this.onFontSizePopoverRef.bind(this);
        this.onPresetControllerRef = this.onPresetControllerRef.bind(this);
        this.onFunctionControllerRef = this.onFunctionControllerRef.bind(this);
        this.onNoteExtControllerRef = this.onNoteExtControllerRef.bind(this);
        this.onPropertyTransferControllerRef = this.onPropertyTransferControllerRef.bind(this);
        this.onAddStateControllerRef = this.onAddStateControllerRef.bind(this);
        this.onAttributeControllerRef = this.onAttributeControllerRef.bind(this);

        this.onPropertyTransferControllerResize = this.onPropertyTransferControllerResize.bind(this);
        this.onNoteExtControllerResize = this.onNoteExtControllerResize.bind(this);

        this.onFontSizeDecBtnPressed = this.onFontSizeDecBtnPressed.bind(this);
        this.onFontSizeIncBtnPressed = this.onFontSizeIncBtnPressed.bind(this);
        this.onFontSizeBtnLongPressed = this.onFontSizeBtnLongPressed.bind(this);
        this.onFontSizeChange = this.onFontSizeChange.bind(this);
        this.onToggleFontSizePopover = this.onToggleFontSizePopover.bind(this);
        this.onTextColorBtnChange = this.onTextColorBtnChange.bind(this);
        this.onBackgroundColorBtnChange = this.onBackgroundColorBtnChange.bind(this);
        this.onBorderColorBtnChange = this.onBorderColorBtnChange.bind(this);
        this.onLineColorBtnChange = this.onLineColorBtnChange.bind(this);
        this.onBorderShownBtnPressed = this.onBorderShownBtnPressed.bind(this);
        this.onCornerRadiusChange = this.onCornerRadiusChange.bind(this);
        this.onPaddingChange = this.onPaddingChange.bind(this);
        this.onLinkPointSizeChange = this.onLinkPointSizeChange.bind(this);

        this.onHAlignmentPressed = this.onHAlignmentPressed.bind(this);
        this.onVAlignmentPressed = this.onVAlignmentPressed.bind(this);
        this.closeHAlignmentMenu = this.closeHAlignmentMenu.bind(this);
        this.closeVAlignmentMenu = this.closeVAlignmentMenu.bind(this);
        this.changeHAlignment = this.changeHAlignment.bind(this);
        this.changeVAlignment = this.changeVAlignment.bind(this);

        this.hAlignment = [
            {id: 0, icon: OEIconCodes.noteHAlignmentLeft}, 
            {id: 1, icon: OEIconCodes.noteHAlignmentCenter},
            {id: 2, icon: OEIconCodes.noteHAlignmentRight}
        ];

        this.vAlignment = [
            {id: 0, icon: OEIconCodes.noteVAlignmentTop},
            {id: 1, icon: OEIconCodes.noteVAlignmentCenter},
            {id: 2, icon: OEIconCodes.noteVAlignmentBottom}
        ];

        this.onPresetBtnPressed = this.onPresetBtnPressed.bind(this);
        this.onFunctionBtnPressed = this.onFunctionBtnPressed.bind(this);
        this.onStyleExtBtnPressed = this.onStyleExtBtnPressed.bind(this);
        this.onPropertyTransferBtnPressed = this.onPropertyTransferBtnPressed.bind(this);
        this.onAddStateBtnPressed = this.onAddStateBtnPressed.bind(this);
        this.onAttributeBtnPressed = this.onAttributeBtnPressed.bind(this);
        this.onTogglePresetController = this.onTogglePresetController.bind(this);
        this.onToggleFunctionController = this.onToggleFunctionController.bind(this);
        this.onToggleStyleExtController = this.onToggleStyleExtController.bind(this);
        this.onTogglePropertyTransferController = this.onTogglePropertyTransferController.bind(this);
        this.onToggleAddStateController = this.onToggleAddStateController.bind(this);
        this.onToggleAttributeController = this.onToggleAttributeController.bind(this);

        this.onIsInDocumentBtnPressed = this.onIsInDocumentBtnPressed.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.id !== this.props.id)     {
            this.id = typeof(nextProps.id) === 'number' ? nextProps.id : null;
            this.setState({id: this.id});
        }
    }

    forceUpdatePopovers()   {
        if(this.fontSizePopoverRef)                 this.fontSizePopoverRef.forceUpdate();
        if(this.presetControllerRef)                this.presetControllerRef.forceUpdate();
        if(this.functionControllerRef)              this.functionControllerRef.forceUpdate();
        if(this.noteExtControllerRef)               this.noteExtControllerRef.forceUpdate();
        if(this.propertyTransferControllerRef)      this.propertyTransferControllerRef.forceUpdate();
        if(this.addStateControllerRef)              this.addStateControllerRef.forceUpdate();
        if(this.attributeControllerRef)             this.attributeControllerRef.forceUpdate();
    }

    isViewOpen(viewType)    {
        return this.state.openViews.findIndex(entry => entry !== null && entry.type === viewType) >= 0;
    }

    openView(viewType)  {
        if(typeof(viewType) !== 'string' || this.isViewOpen(viewType))  return;

        let openViews = this.state.openViews.slice();
        let newEntry = {type: viewType, order: 0};

        if(openViews.length === 0)  {
            openViews.push(newEntry);
        } else if(openViews.length === 2)  {
            newEntry.order = openViews[1].order;
            openViews.splice(1, 1);
            openViews.splice(0, 0, newEntry);
        } else {
            newEntry.order = (openViews[0].order + 1) % 2;
            openViews.splice(0, 0, newEntry);
        }

        this.setState({openViews: openViews});
    }

    closeView(viewType) {
        if(typeof(viewType) !== 'string')   return;
        let openViews = this.state.openViews.slice();
        let i = openViews.findIndex(entry => entry !== null && entry.type === viewType);
        if(i < 0)   return;
        openViews.splice(i, 1);
        this.setState({openViews: openViews});
        if(this.props.updateRectIfNeeded)   this.props.updateRectIfNeeded();
    }

    toogleView(viewType)    {
        if(!this.isViewOpen(viewType))  {
            this.openView(viewType);
        } else {
            this.closeView(viewType);
        }
    }

    getViewPlacement(viewType, defaultPlacement = 'right-start')    {
        if(typeof(viewType) !== 'string')   return defaultPlacement;
        let i = this.state.openViews.findIndex(entry => entry !== null && entry.type === viewType);
        if(i < 0)   return defaultPlacement;
        return this.state.openViews[i].order === 0 ? 'right-start' : 'left-start';
    }

    closeViews() {
        this.setState({
            isFontSizePopoverOpen:          false,
            isHAlignmentMenuOpen:           false,
            isVAlignmentMenuOpen:           false,
            isPresetPopoverOpen:            false,
            openViews:                      []
        });
    }

    onConnect()  {
    }

    onRelease()    {
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.closeViews();
            return;
        }
    }

    onNoteStateChanged(sender, noteState)   {
        this.setState({noteState: clone(noteState)});
    }

    onFontSizePopoverRef(ref)   {
        this.fontSizePopoverRef = ref;
    }

    onPresetControllerRef(ref)  {
        this.presetControllerRef = ref;
    }

    onFunctionControllerRef(ref)    {
        this.functionControllerRef = ref;
    }

    onNoteExtControllerRef(ref)    {
        this.noteExtControllerRef = ref;
    }

    onPropertyTransferControllerRef(ref)   {
        this.propertyTransferControllerRef = ref;
    }

    onAddStateControllerRef(ref)   {
        this.addStateControllerRef = ref;
    }

    onAttributeControllerRef(ref)   {
        this.attributeControllerRef = ref;
    }

    onNoteExtControllerResize(sender, size) {
        if(this.noteExtControllerRef)  this.noteExtControllerRef.forceUpdate();
    }

    onPropertyTransferControllerResize(sender, size)    {
        if(this.propertyTransferControllerRef)  this.propertyTransferControllerRef.forceUpdate();
    }

    getHAlignmentIcon() {
        let value = this.state.noteState.style.hAlignment >= 0 && this.state.noteState.style.hAlignment < this.hAlignment.length ? this.state.noteState.style.hAlignment : 0;
        return this.hAlignment[value].icon;
    }

    getVAlignmentIcon() {
        let value = this.state.noteState.style.vAlignment >= 0 && this.state.noteState.style.vAlignment < this.vAlignment.length ? this.state.noteState.style.vAlignment : 0;
        return this.vAlignment[value].icon;
    }

    render()    {

        const fontSizeController = !this.props.devFeatures ? null :
            <OENumberPickerPopover
                ref={this.onFontSizePopoverRef}
                moduleId={this.props.moduleId}
                boundariesElement={this.props.boundariesElement}
                target="note-font-size-btns"
                isOpen={this.state.isFontSizePopoverOpen}
                onToggle={this.onToggleFontSizePopover}
                components={[{
                    minValue: 5,
                    maxValue: 255,
                    inc: 1,
                    precision: 0
                }]}
                value={this.state.noteState.style.fontSize}
                onChange={this.onFontSizeChange}
            />;

        const hAlignment = !this.props.devFeatures ? null :
            <OEPopoverMenu 
                moduleId={this.props.moduleId}
                boundariesElement={this.props.boundariesElement}
                target="note-hAlignment-btn"
                isOpen={this.state.isHAlignmentMenuOpen}
                onToggle={this.closeHAlignmentMenu}
                entries={this.hAlignment}
                onChange={this.changeHAlignment}
            />;

        const vAlignment = !this.props.devFeatures ? null :
            <OEPopoverMenu 
                moduleId={this.props.moduleId}
                boundariesElement={this.props.boundariesElement}
                target="note-vAlignment-btn"
                isOpen={this.state.isVAlignmentMenuOpen}
                onToggle={this.closeVAlignmentMenu}
                entries={this.vAlignment}
                onChange={this.changeVAlignment}
            />;

        const presetController = !this.props.devFeatures ? null :
            <OEPresetPopoverController
                ref={this.onPresetControllerRef}
                moduleId={this.props.moduleId}
                appComponent={this.props.appComponent}
                boundariesElement={this.props.boundariesElement}
                target="note-preset-btn"
                isOpen={this.state.isPresetPopoverOpen}
                onToggle={this.onTogglePresetController}
                titleId="note_preset_view"
                presetType={OEPresetType.note}
                refId={this.state.id}
                backdrop={true}
                backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
            />;

        const functionController = !this.props.devFeatures ? null :
            <OENoteFunctionPopoverController
                ref={this.onFunctionControllerRef}
                moduleId={this.props.moduleId}
                className="with-backdrop"
                id={this.state.id}
                boundariesElement={this.props.boundariesElement}
                target={this.props.popoverTargetId}
                placement={this.getViewPlacement(OENoteToolbarViewTypes.function)}
                hideArrow={true}
                isOpen={this.isViewOpen(OENoteToolbarViewTypes.function)}
                onToggle={this.onToggleFunctionController}
                backdrop={false}
                backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
                devFeatures={this.props.devFeatures}
            />;

        const noteExtController = !this.props.devFeatures ? null :
            <OENoteExtPopoverController
                ref={this.onNoteExtControllerRef}
                moduleId={this.props.moduleId}
                className="with-backdrop"
                appComponent={this.props.appComponent}
                id={this.state.id}
                boundariesElement={this.props.boundariesElement}
                target={this.props.popoverTargetId}
                placement={this.getViewPlacement(OENoteToolbarViewTypes.styleExt)}
                hideArrow={true}
                noHeader={true}
                isOpen={this.isViewOpen(OENoteToolbarViewTypes.styleExt)}
                onToggle={this.onToggleStyleExtController}
                backdrop={false}
                backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
                devFeatures={this.props.devFeatures}
                onResize={this.onNoteExtControllerResize}
            />;

        const propertyTransferController = !this.props.devFeatures ? null :
            <OENotePropertyTransferPopoverController
                ref={this.onPropertyTransferControllerRef}
                moduleId={this.props.moduleId}
                className="with-backdrop"
                appComponent={this.props.appComponent}
                id={this.state.id}
                boundariesElement={this.props.boundariesElement}
                target={this.props.popoverTargetId}
                placement={this.getViewPlacement(OENoteToolbarViewTypes.propertyTransfer)}
                hideArrow={true}
                noHeader={true}
                isOpen={this.isViewOpen(OENoteToolbarViewTypes.propertyTransfer)}
                onToggle={this.onTogglePropertyTransferController}
                backdrop={false}
                backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
                onResize={this.onPropertyTransferControllerResize}
            />;

        const addStateController = !this.props.devFeatures ? null :
            <OENoteAddStatePopoverController
                ref={this.onAddStateControllerRef}
                moduleId={this.props.moduleId}
                className="with-backdrop"
                appComponent={this.props.appComponent}
                id={this.state.id}
                boundariesElement={this.props.boundariesElement}
                target={this.props.popoverTargetId}
                placement={this.getViewPlacement(OENoteToolbarViewTypes.addState)}
                hideArrow={true}
                noHeader={true}
                isOpen={this.isViewOpen(OENoteToolbarViewTypes.addState)}
                onToggle={this.onToggleAddStateController}
                backdrop={false}
                backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
            />;

        const attributeController = !this.props.devFeatures ? null :
            <OENoteAttributePopoverController
                ref={this.onAttributeControllerRef}
                moduleId={this.props.moduleId}
                className="with-backdrop"
                appComponent={this.props.appComponent}
                id={this.state.id}
                boundariesElement={this.props.boundariesElement}
                target={this.props.popoverTargetId}
                placement={this.getViewPlacement(OENoteToolbarViewTypes.attribute)}
                hideArrow={true}
                noHeader={true}
                isOpen={this.isViewOpen(OENoteToolbarViewTypes.attribute)}
                onToggle={this.onToggleAttributeController}
                backdrop={false}
                backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
                devFeatures={this.props.devFeatures}
            />;

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OENoteStateProvider moduleId={this.props.moduleId} id={this.props.id} onNoteStateChanged={this.onNoteStateChanged}/>

                <div className="note-toolbar">

                    <div className="note-toolbar-button-group">

                        <div id="note-font-size-btns" className="font-size-btns">
                            <OEIconButton className="transparent-btn btns-font-dec" icon={OEIconCodes.noteDecFont} onPressed={this.onFontSizeDecBtnPressed} onLongPressed={this.props.devFeatures ? this.onFontSizeBtnLongPressed : null}/>

                            <OEIconButton className="transparent-btn" icon={OEIconCodes.noteIncFont} onPressed={this.onFontSizeIncBtnPressed} onLongPressed={this.props.devFeatures ? this.onFontSizeBtnLongPressed : null}/>
                        </div>

                        <OEColorPickerButton
                            moduleId={this.props.moduleId}
                            className="transparent-btn"
                            boundariesElement={this.props.boundariesElement}
                            noHeader={true}
                            backdrop={true}
                            backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
                            color={this.state.noteState.style.textColor}
                            defaultColor={{x: 0, y: 0, z: 0, w: 1}}
                            hasAlphaControl={true}
                            numericInput={this.props.devFeatures ? OEColorPickerNumericInputType.textField : OEColorPickerNumericInputType.rgbInput}
                            hasPaletteButton={this.props.devFeatures}
                            onChange={this.onTextColorBtnChange}
                        >
                            <OEIcon code={OEIconCodes.noteTextColor}/>

                            <OEIcon className="color-bar" style={{color: OEColor.toDOMStr(this.state.noteState.style.textColor)}} code={OEIconCodes.noteShowColor}/>
                        </OEColorPickerButton>

                        <OEColorPickerButton
                            moduleId={this.props.moduleId}
                            className="transparent-btn"
                            boundariesElement={this.props.boundariesElement}
                            noHeader={true}
                            backdrop={true}
                            backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
                            color={this.state.noteState.style.borderColor}
                            defaultColor={{x: 0, y: 0, z: 0, w: 1}}
                            hasAlphaControl={true}
                            numericInput={this.props.devFeatures ? OEColorPickerNumericInputType.textField : OEColorPickerNumericInputType.rgbInput}
                            hasPaletteButton={this.props.devFeatures}
                            onChange={this.onBorderColorBtnChange}
                        >
                            <OEIcon className="primary" code={OEIconCodes.noteBorderColor1}/>
                            <OEIcon className="secondary" code={OEIconCodes.noteBorderColor2}/>

                            <OEIcon className="color-bar" style={{color: OEColor.toDOMStr(this.state.noteState.style.borderColor)}} code={OEIconCodes.noteShowColor}/>
                        </OEColorPickerButton>

                        <OEColorPickerButton
                            moduleId={this.props.moduleId}
                            className="transparent-btn"
                            boundariesElement={this.props.boundariesElement}
                            noHeader={true}
                            backdrop={true}
                            backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
                            color={this.state.noteState.style.lineColor}
                            defaultColor={{x: 0, y: 0, z: 0, w: 1}}
                            hasAlphaControl={true}
                            numericInput={this.props.devFeatures ? OEColorPickerNumericInputType.textField : OEColorPickerNumericInputType.rgbInput}
                            hasPaletteButton={this.props.devFeatures}
                            onChange={this.onLineColorBtnChange}
                        >
                            <OEIcon className="primary note-line-color" code={OEIconCodes.noteLineColor}/>
                            <OEIcon className="secondary note-line-color" code="|"/>

                            <OEIcon className="color-bar" style={{color: OEColor.toDOMStr(this.state.noteState.style.lineColor)}} code={OEIconCodes.noteShowColor}/>
                        </OEColorPickerButton>

                        <OEColorPickerButton
                            moduleId={this.props.moduleId}
                            className="transparent-btn"
                            boundariesElement={this.props.boundariesElement}
                            noHeader={true}
                            backdrop={true}
                            backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
                            color={this.state.noteState.style.backgroundColor}
                            defaultColor={{x: 1, y: 1, z: 1, w: 1}}
                            hasAlphaControl={true}
                            numericInput={this.props.devFeatures ? OEColorPickerNumericInputType.textField : OEColorPickerNumericInputType.rgbInput}
                            hasPaletteButton={this.props.devFeatures}
                            onChange={this.onBackgroundColorBtnChange}
                        >
                            <OEIcon code={OEIconCodes.noteBackgroundColor}/>

                            <OEIcon className="color-bar" style={{color: OEColor.toDOMStr(this.state.noteState.style.backgroundColor)}} code={OEIconCodes.noteShowColor}/>
                        </OEColorPickerButton>

                        <OEIconButton className="transparent-btn" icon={this.state.noteState.style.hasBorder ? OEIconCodes.noteBorder : OEIconCodes.noteNoBorder} onPressed={this.onBorderShownBtnPressed}/>

                        {!this.props.devFeatures ? null :
                            <OENumberPickerButton
                                moduleId={this.props.moduleId}
                                className="transparent-btn"
                                boundariesElement={this.props.boundariesElement}
                                components={[{
                                        minValue: 0,
                                        maxValue: 32,
                                        inc: 1,
                                        precision: 0
                                    }]}
                                value={this.state.noteState.style.cornerRadius}
                                onChange={this.onCornerRadiusChange}
                                icon={OEIconCodes.noteCornerRadius}
                                highlightButton={false}
                            />
                        }

                        {!this.props.devFeatures ? null :
                            <OENumberPickerButton
                                moduleId={this.props.moduleId}
                                className="transparent-btn"
                                boundariesElement={this.props.boundariesElement}
                                components={[{
                                        minValue: 0,
                                        maxValue: 32,
                                        inc: 1,
                                        precision: 0
                                    }]}
                                value={(this.state.noteState.style.padding.x + this.state.noteState.style.padding.y + this.state.noteState.style.padding.z + this.state.noteState.style.padding.w) / 4}
                                onChange={this.onPaddingChange}
                                icon={OEIconCodes.notePadding}
                                highlightButton={false}
                            />
                        }

                        <OENumberPickerButton
                            moduleId={this.props.moduleId}
                            className="transparent-btn"
                            iconClassName="primary link-point-size"
                            boundariesElement={this.props.boundariesElement}
                            components={[{
                                minValue: 0,
                                maxValue: 10,
                                inc: 0.5,
                                precision: 1
                            }]}
                            value={this.state.noteState.style.linkPointSize}
                            onChange={this.onLinkPointSizeChange}
                            icon={OEIconCodes.noteLinkPointSize1}
                            highlightButton={false}
                        >
                            <OEIcon className="secondary link-point-size" code={OEIconCodes.noteLinkPointSize2}/>
                            <OEIcon className="tertiary link-point-size" code="|"/>
                        </OENumberPickerButton>

                        {this.props.devFeatures ? <OEIconButton id="note-ext-btn" className="transparent-btn note-ext" activated={this.isViewOpen(OENoteToolbarViewTypes.styleExt)} icon={OEIconCodes.noteExt} onPressed={this.onStyleExtBtnPressed}/> : null}

                        {this.props.devFeatures ? <OEIconButton id="note-add-state-btn" className="transparent-btn add-state" activated={this.isViewOpen(OENoteToolbarViewTypes.addState)} icon={OEIconCodes.noteAddState} onPressed={this.onAddStateBtnPressed}/> : null}

                    </div>

                    <div className="note-toolbar-button-group">
                        {this.props.devFeatures ? <OEIconButton id="note-hAlignment-btn" className="transparent-btn hAlignment" icon={this.getHAlignmentIcon()} onPressed={this.onHAlignmentPressed}/> : null}

                        {this.props.devFeatures ? <OEIconButton id="note-vAlignment-btn" className="transparent-btn vAlignment" icon={this.getVAlignmentIcon()} onPressed={this.onVAlignmentPressed}/> : null}
                    </div>

                    <div className="note-toolbar-button-group">
                        {this.props.devFeatures ? <OEIconButton id="note-property-transfer-btn" className="transparent-btn property-transfer" iconClassName="rotate-180" activated={this.isViewOpen(OENoteToolbarViewTypes.propertyTransfer)} icon={OEIconCodes.notePropertyTransfer} onPressed={this.onPropertyTransferBtnPressed}/> : null}

                        {this.props.devFeatures ? <OEIconButton id="note-preset-btn" className="transparent-btn preset" icon={OEIconCodes.notePreset} onPressed={this.onPresetBtnPressed}/> : null}

                        {this.props.devFeatures ? <OEIconButton id="note-function-btn" className="transparent-btn function" activated={this.isViewOpen(OENoteToolbarViewTypes.function)} icon={OEIconCodes.noteFunction} onPressed={this.onFunctionBtnPressed}/> : null}

                        {this.props.devFeatures ? <OEIconButton id="note-attribute-btn" className="transparent-btn attribute" activated={this.isViewOpen(OENoteToolbarViewTypes.attribute)} icon={OEIconCodes.noteAttribute} onPressed={this.onAttributeBtnPressed}/> : null}
                    </div>

                    {this.props.devFeatures ? <OEIconButton className="transparent-btn is-in-document" icon={this.state.noteState.isInDocument ? OEIconCodes.noteIsInDocument : OEIconCodes.noteIsNotInDocument} onPressed={this.onIsInDocumentBtnPressed}/> : null}
                </div>

                {fontSizeController}
                {hAlignment}
                {vAlignment}
                {presetController}
                {functionController}
                {noteExtController}
                {propertyTransferController}
                {addStateController}
                {attributeController}

            </React.Fragment>
        )
    }

    onFontSizeDecBtnPressed()	{
        if(!this.oe.isReady() || this.id === null) return;
        var noteController = this.oe.sharedInterface.getUIControllerNote();
        if(noteController.getNoteFontSize(this.id) > 5) {
            noteController.incNoteFontSize(this.id, -1);
        }
    }

    onFontSizeIncBtnPressed()	{
        if(!this.oe.isReady() || this.id === null) return;
        var noteController = this.oe.sharedInterface.getUIControllerNote();
        if(noteController.getNoteFontSize(this.id) < 64 || (this.props.devFeatures && noteController.getNoteFontSize(this.id) < 255))    {
            noteController.incNoteFontSize(this.id, 1);
        }
    }

    onFontSizeBtnLongPressed()  {
        this.setState({isFontSizePopoverOpen: true});
    }

    onFontSizeChange(values)  {
        if(!this.oe.isReady() || this.id === null || !Array.isArray(values) || values.length < 1) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteFontSize(this.id, values[0]);
    }

    onToggleFontSizePopover()  {
        this.setState({isFontSizePopoverOpen: false});
    }

    onTextColorBtnChange(sender, color)	{
        if(!this.oe.isReady() || this.id === null) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteTextColor(this.id, color);
    }

    onBackgroundColorBtnChange(sender, color)	{
        if(!this.oe.isReady() || this.id === null) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteBackgroundColor(this.id, color);
    }

    onBorderColorBtnChange(sender, color)	{
        if(!this.oe.isReady() || this.id === null) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteBorderColor(this.id, color);
    }

    onLineColorBtnChange(sender, color)	{
        if(!this.oe.isReady() || this.id === null) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteLineColor(this.id, color);
    }

    onBorderShownBtnPressed()   {
        if(!this.oe.isReady() || this.id === null) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteHasBorder(this.id, !this.state.noteState.style.hasBorder);
    }

    onCornerRadiusChange(values)  {
        if(!this.oe.isReady() || this.id === null || !Array.isArray(values) || values.length < 1) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteCornerRadius(this.id, values[0]);
    }

    onPaddingChange(values)  {
        if(!this.oe.isReady() || this.id === null || !Array.isArray(values) || values.length < 1) return;
        this.oe.sharedInterface.getUIControllerNote().setNotePaddingAll(this.id, values[0]);
    }

    onLinkPointSizeChange(values)  {
        if(!this.oe.isReady() || this.id === null || !Array.isArray(values) || values.length < 1) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteLinkPointSize(this.id, values[0]);
    }
    
    onHAlignmentPressed() {
        this.setState({isHAlignmentMenuOpen: true});
    }

    onVAlignmentPressed() {
        this.setState({isVAlignmentMenuOpen: true});
    }

    closeHAlignmentMenu() {
        this.setState({isHAlignmentMenuOpen: false});
    }

    closeVAlignmentMenu() {
        this.setState({isVAlignmentMenuOpen: false});
    }

    changeHAlignment(id) {
        if(!this.oe.isReady() || this.id === null) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteHAlignment(this.id, {value: id});
        this.closeHAlignmentMenu();
    }

    changeVAlignment(id) {
        if(!this.oe.isReady() || this.id === null) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteVAlignment(this.id, {value: id});
        this.closeVAlignmentMenu();
    }

    onPresetBtnPressed() {
        this.setState({isPresetPopoverOpen: true});
    }

    onFunctionBtnPressed() {
        this.toogleView(OENoteToolbarViewTypes.function);
    }

    onStyleExtBtnPressed() {
        this.toogleView(OENoteToolbarViewTypes.styleExt);
    }

    onPropertyTransferBtnPressed() {
        this.toogleView(OENoteToolbarViewTypes.propertyTransfer);
    }

    onAddStateBtnPressed() {
        this.toogleView(OENoteToolbarViewTypes.addState);
    }

    onAttributeBtnPressed() {
        this.toogleView(OENoteToolbarViewTypes.attribute);
    }

    onTogglePresetController() {
        this.setState({isPresetPopoverOpen: false});
    }

    onToggleFunctionController() {
        this.closeView(OENoteToolbarViewTypes.function);
    }

    onToggleStyleExtController() {
        this.closeView(OENoteToolbarViewTypes.styleExt);
    }

    onTogglePropertyTransferController() {
        this.closeView(OENoteToolbarViewTypes.propertyTransfer);
    }

    onToggleAddStateController() {
        this.closeView(OENoteToolbarViewTypes.addState);
    }

    onToggleAttributeController() {
        this.closeView(OENoteToolbarViewTypes.attribute);
    }
    
    onIsInDocumentBtnPressed()  {
        if(!this.oe.isReady() || this.id === null) return;
        this.oe.sharedInterface.getUIControllerNote().setNoteIsInDocument(this.id, !this.state.noteState.isInDocument);
    }
}

OENoteToolbar.defaultProps = {
    moduleId:               ''
};

OENoteToolbar.propTypes = {
    appComponent:           PropTypes.object,
    moduleId:               PropTypes.string,
    id:                     PropTypes.number,
    popoverTargetId:        PropTypes.string,
    devFeatures:            PropTypes.bool,
    updateRectIfNeeded:     PropTypes.func
};